export const shotTrackerConstants = {
    scorecardRouteToHoleConfig: 'liveShotView.scorecardRouteToHoleConfig',
    initialContext: 'eventCentreParams.initialContext',
    clipTagParameters: 'clipTagParameters',
    teamNo: 'teamNo',
    roundNo: 'roundNo',
    holeNo: 'holeNo',
    groupId: 'groupId',
    view: 'view'
}